/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RescheduleMatchBody
 */
export interface RescheduleMatchBody {
    /**
     * New scheduled time (epoch ms)
     * @type {number}
     * @memberof RescheduleMatchBody
     */
    scheduledTime: number;
    /**
     * Reason for rescheduling
     * @type {string}
     * @memberof RescheduleMatchBody
     */
    reason?: string;
}

/**
 * Check if a given object implements the RescheduleMatchBody interface.
 */
export function instanceOfRescheduleMatchBody(value: object): value is RescheduleMatchBody {
    if (!('scheduledTime' in value) || value['scheduledTime'] === undefined) return false;
    return true;
}

export function RescheduleMatchBodyFromJSON(json: any): RescheduleMatchBody {
    return RescheduleMatchBodyFromJSONTyped(json, false);
}

export function RescheduleMatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RescheduleMatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'scheduledTime': json['scheduledTime'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function RescheduleMatchBodyToJSON(json: any): RescheduleMatchBody {
    return RescheduleMatchBodyToJSONTyped(json, false);
}

export function RescheduleMatchBodyToJSONTyped(value?: RescheduleMatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scheduledTime': value['scheduledTime'],
        'reason': value['reason'],
    };
}

